<template>
  <div class="management-content wrap1-box">
    <ul>
      <li class="management-item" v-for="(pfa, index) in attendanceData.pfa_list" :key="pfa.id">
        <h1 class="common-title">
          <span>
            <i v-if="index === 0" class="el-icon-arrow-left back" @click="handlerBack"></i>
            {{ $t('payroll_management_7', { key: index + 1 }) }}
          </span>
          <i class="el-icon-delete icon" v-if="attendanceData.pfa_list.length > 1" @click="handleDel(index)"></i>
        </h1>
        <el-form ref="payee-info" label-width="200px" class="management-form" :model="pfa">
          <!-- 选择人员 -->
          <el-form-item
            :label="$t('payroll_management_8')"
            :prop="pfa.department_list && pfa.department_list.length ? 'department_list' : 'staff_list'"
            :rules="{ required: true, trigger: ['blur', 'change'], message: $t('1593') }"
          >
            <el-input
              @focus="openOrg(pfa, index)"
              :value="$t('912', { y: pfa.staff_info_ids.length || 0, x: pfa.department_id.length || 0 })"
            ></el-input>
            <org
              v-if="pfa.orgVisible"
              @onConfirm="handleSelectDepart"
              :visible.sync="pfa.orgVisible"
              :defaultDepatment="pfa.department_list"
              :defaultEmployess="pfa.staff_list"
              isRegister="1"
            />
          </el-form-item>
          <!-- 是否扣税与社保 -->
          <el-form-item :label="$t('payroll_management_9')">
            {{ $t('payroll_management_10') }} <el-switch v-model="pfa.my_is_tax"></el-switch>
            <!-- <el-switch v-model="pfa.my_is_tax" active-color="#E6A23C"></el-switch> -->
            {{ $t('payroll_management_11') }} <el-switch v-model="pfa.my_is_ss"></el-switch>
            <!-- <el-switch v-model="pfa.my_is_ss" active-color="#E6A23C"></el-switch> -->
          </el-form-item>
          <!-- 不发放条件 -->
          <el-form-item :label="$t('payroll_management_24')">
            <el-select v-model="pfa.provide_condition" multiple :placeholder="$t('221')">
              <el-option
                v-for="item in attendanceData.conditions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <p class="tip">{{ $t('payroll_management_13') }}</p>
          </el-form-item>
          <!-- 发放方式 -->
          <el-form-item
            :label="$t('payroll_management_12')"
            :rules="{ required: true, trigger: ['blur', 'change'], message: $t('1593') }"
          >
            <el-radio-group v-model="pfa.provide_way">
              <el-radio label="0">{{ $t('1632') }}</el-radio>
              <el-radio label="1">{{ $t('payroll_management_14') }}</el-radio>
            </el-radio-group>
            <!-- 固定额度 -->
            <div v-if="pfa.provide_way === '0'">
              <el-form-item
                prop="provide_way_0"
                :rules="{ required: true, trigger: ['blur', 'change'], message: $t('1593') }"
              >
                {{ $t('payroll_management_15') }}
                <el-input v-model.number="pfa.provide_way_0" v-enterNumberPoint2 style="width: 120px"></el-input>
                {{ currency }}
              </el-form-item>
            </div>
            <!-- 逐月递增 -->
            <div v-if="pfa.provide_way === '1'" class="provide_way">
              <div v-for="(way, key, cIndex) in pfa.provide_way_1" :key="key" class="provide_way_item">
                <el-form-item
                  class="provide_way_item"
                  :label="$t('payroll_management_12')"
                  :prop="`provide_way_1.${key}`"
                  :rules="[{ required: true, trigger: ['blur', 'change'], message: $t('1593') }]"
                >
                  <span v-if="cIndex === 0">{{ $t('payroll_management_17') }} </span>
                  <span v-else>{{ $t('payroll_management_18', { key: cIndex + 1 }) }} </span>
                  <el-input v-model.number="pfa.provide_way_1[key]" v-enterNumberPoint2 style="width: 120px"></el-input>
                  {{ currency }}
                  <i
                    class="icon el-icon-delete"
                    @click="handlerDelete(pfa, key)"
                    v-if="cIndex > 1 && Object.keys(pfa.provide_way_1).length === cIndex + 1"
                  ></i>
                </el-form-item>
              </div>
              <el-button class="add-more" type="text" @click="handlerEdit(pfa)">
                <i class="el-icon-circle-plus-outline"></i>
                {{ $t('payroll_management_26') }}
              </el-button>
              <span class="tip">{{ $t('payroll_management_19') }}</span>
            </div>
          </el-form-item>
        </el-form>
      </li>
      <el-button class="add-item" icon="el-icon-plus" @click="handleAdd">{{ $t('payroll_management_25') }}</el-button>
    </ul>
    <el-row class="flex-btn">
      <el-button @click="handlerBack"> {{ $t('66') }} </el-button>
      <el-button type="primary" @click="onConfirm" v-if="$p('menu.payroll.management.edit')">
        {{ $t('131') }}
      </el-button>
    </el-row>
  </div>
</template>

<script>
import './directive'
import org from '@/components/organization/'
import rdiff from 'recursive-diff'
import { saveFullAttendanceBonus, fullAttendanceBonusList } from '@/api/payroll/management'
import { mapState } from 'vuex'
export default {
  components: {
    org
  },
  props: {
    currentData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      // 货币
      currency: state => state.user.company_info.currency
    })
  },
  data() {
    return {
      orgIndex: 0,
      cAttendanceData: {},
      // 当前选中项
      attendanceData: {
        name: 'payroll_management_21',
        is_setting: false,
        status: '0',
        conditions: [],
        pfa_list: [
          {
            my_is_tax: false,
            my_is_ss: false,
            is_ss: '0', // 是否社保 0 关闭 1开启
            is_tax: '0', // 是否算税 0 关闭 1开启
            provide_condition: [], // 生效规则
            provide_way: '0', // 0固定额度，1递增额度
            provide_way_0: '', // 固定额度的值
            provide_way_1: { 1: '', 2: '' }, // 递增额度的值
            staff_info_ids: [], // 用户id
            department_id: [], // 部门id
            department_list: [],
            staff_list: []
          }
        ]
      },
      status: false
    }
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener('popstate', window.pushStateFun, false)
    if (this.status) next()
    else {
      const diff = rdiff.getDiff(this.attendanceData.pfa_list, this.cAttendanceData.pfa_list)
      if (!diff.length) next()
      else {
        this.$confirm(this.$t('payroll_management_28'), this.$t('payroll_management_27'), {
          confirmButtonText: this.$t('submit_btn'),
          cancelButtonText: this.$t('cancel_btn'),
          type: 'warning'
        })
          .then(() => {
            next()
          })
          .catch(() => {})
      }
    }
  },
  mounted() {
    this.handleEdit()
    this.preventBack()
  },
  methods: {
    preventBack() {
      const this_ = this
      window.pushStateFun = function () {
        const diff = rdiff.getDiff(this_.attendanceData.pfa_list, this_.cAttendanceData.pfa_list)
        if (!diff.length) this_.handlerBack()
        else {
          this_
            .$confirm(this_.$t('payroll_management_28'), this_.$t('payroll_management_27'), {
              confirmButtonText: this_.$t('submit_btn'),
              cancelButtonText: this_.$t('cancel_btn'),
              type: 'warning'
            })
            .then(() => {
              this_.status = true
              this_.handlerBack()
            })
            .catch(() => {
              const state = {
                title: null,
                url: document.UTL // 要禁掉的页面
              }
              /*
                  三个参数：
                  state：一个与指定网址相关的状态对象，popstate事件触发时，该对象会传入回调函数。如果不需要这个对象，此处可以填null。
                  title：新页面的标题，但是所有浏览器目前都忽略这个值，因此这里可以填null。
                  url：新的网址，必须与当前页面处在同一个域。浏览器的地址栏将显示这个网址。
                */
              window.history.pushState(state, null, document.UTL) // 要禁掉的页面
            })
        }
      }
      const state = {
        title: null,
        url: document.UTL // 要禁掉的页面
      }
      window.history.pushState(state, null, document.UTL) // 要禁掉的页面
      window.addEventListener('popstate', window.pushStateFun, false)
    },
    handlerBack() {
      // 返回列表页
      this.$router.push({ path: '/payroll/items' })
    },
    async handleEdit() {
      const res = await fullAttendanceBonusList()
      if (!(res.code === 1 && res.data)) return
      const data = res.data
      const pfaStatus = data.pfa_list && data.pfa_list.length
      this.attendanceData.conditions = data.conditions
      this.attendanceData.pfa_list = pfaStatus ? data.pfa_list : this.attendanceData.pfa_list
      this.attendanceData.pfa_list.forEach(item => {
        item.provide_way_1 = item.provide_way_1 ? item.provide_way_1 : { 1: '', 2: '' }
        this.$set(item, 'orgVisible', false) // 选择人员弹窗
        this.$set(item, 'my_is_tax', item.is_tax === '1') // 计算税
        this.$set(item, 'my_is_ss', item.is_ss === '1') // 社保
        this.$set(item, 'department_list', item.department_id) // 选择人员需向弹窗传的参数
        this.$set(item, 'staff_list', item.staff_info_ids) // 选择人员需向弹窗传的参数
        // 千分位
        item.provide_way_0 = Number(item.provide_way_0).toLocaleString()
        // 发放条件为逐月递增 provide_way_1的值是否为空
        if (item.provide_way === '1') {
          Object.keys(item.provide_way_1).forEach(key => {
            // 千分位
            const e = item.provide_way_1[key]
            item.provide_way_1[key] = Number(e).toLocaleString()
          })
        }
        item.department_id = []
        item.staff_info_ids = []
        item.provide_condition = item.provide_condition ? item.provide_condition : []
        // 后端给的数据是数组+对象，在department_id字段中只用保留id
        if (item.department_list.length) {
          item.department_list.forEach(department => {
            department.department_id = department.id
            department.department_name = department.name
            item.department_id.push(department.id)
          })
        }
        // 后端给的数据是数组+对象，在staff_info_ids字段中只用保留id
        const staffs = []
        if (Array.isArray(item.staff_list)) {
          item.staff_list.forEach(staff => {
            item.staff_info_ids.push(staff.id)
            staffs.push({
              staff_id: staff.staff_id || staff.id,
              staff_name: staff.staff_name || staff.name,
              staff_name_en: staff.staff_name_en,
              staff_name_secondary: staff.staff_name_secondary,
              staff_name_th: staff.staff_name_th || staff.name,
              avatar_url: staff.avatar_url || '',
              id: staff.id
            })
          })
        }
        item.staff_list = staffs
      })
      this.cAttendanceData = JSON.parse(JSON.stringify(this.attendanceData))
    },
    // 删除
    handleDel(index) {
      this.$confirm(this.$t('payroll_management_50'), '', {
        confirmButtonText: this.$t('submit_btn'),
        cancelButtonText: this.$t('cancel_btn'),
        type: 'warning'
      })
        .then(() => {
          this.attendanceData.pfa_list.splice(index, 1)
        })
        .catch(() => {})
    },
    handleAdd() {
      this.attendanceData.pfa_list.push({
        my_is_ss: false,
        my_is_tax: false,
        is_ss: '0', // 是否社保 0 关闭 1开启
        is_tax: '0', // 是否算税 0 关闭 1开启
        provide_condition: [], // 生效规则
        orgVisible: false, // 是否展示选择人员弹窗
        provide_way: '0', // 0固定额度，1递增额度
        provide_way_0: '', // 固定额度的值
        provide_way_1: { 1: '', 2: '' }, // 递增额度的值
        staff_info_ids: [], // 用户id
        department_id: [], // 部门id
        staff_list: [],
        department_list: []
      })
    },
    handlerDelete(value, key) {
      this.$delete(value.provide_way_1, key)
    },
    // 逐月递增添加数据
    handlerEdit(value) {
      const keys = Object.keys(value.provide_way_1)
      if (keys.length < 12) {
        this.$set(value.provide_way_1, keys.length + 1, '')
      }
    },
    // 打开选择人员弹窗
    openOrg(pfa, index) {
      this.orgIndex = index
      pfa.orgVisible = true
    },
    // 选择成员
    handleSelectDepart(params) {
      const pfa_list = this.attendanceData.pfa_list
      const item = pfa_list[this.orgIndex]
      item.department_list = params.dept_list
      item.staff_list = params.staff_list
      item.department_id = this.formateList(params.dept_list, 'department_id')
      item.staff_info_ids = this.formateList(params.staff_list, 'staff_id')
      // 其他计算规则中如果有选择相同的部门和人，需删除
      pfa_list.forEach((pfa, pfaIndex) => {
        pfa.staff_list.forEach((staff, staffIndex) => {
          if (pfaIndex !== this.orgIndex) {
            if (params.staffIds.includes(staff.staff_id)) {
              pfa.staff_list.splice(staffIndex, 1)
              pfa.staff_info_ids.splice(staffIndex, 1)
            }
          }
        })
        pfa.department_list.forEach((dep, depIndex) => {
          if (pfaIndex !== this.orgIndex) {
            if (params.depIds.includes(dep.department_id)) {
              pfa.department_list.splice(depIndex, 1)
              pfa.department_id.splice(depIndex, 1)
            }
          }
        })
      })
    },
    // 数据格式化
    formateList(obj, key) {
      return obj.map(item => item[key])
    },
    handleForm() {
      // 判断所有payee - info必填项是否为空
      const validBase = []
      const payeeInfo = this.$refs['payee-info']
      payeeInfo.forEach(async item => {
        item.validate(valid => {
          validBase.push(valid)
        })
      })
      return validBase
    },
    async onConfirm() {
      const validBase = this.handleForm()
      if (validBase.includes(false)) return
      // 必填项不为空执行下面代码
      this.attendanceData.pfa_list.forEach(item => {
        item.is_ss = item.my_is_ss ? '1' : '0'
        item.is_tax = item.my_is_tax ? '1' : '0'
        if (item.provide_condition.length <= 0) delete item.provide_condition
        if (item.provide_way === '0') {
          item.provide_way_1 = {}
          if (isNaN(item.provide_way_0)) item.provide_way_0 = item.provide_way_0.split(',').join('')
        } else {
          item.provide_way_0 = ''
          const keys = Object.keys(item.provide_way_1)
          keys.forEach(key => {
            const i = item.provide_way_1[key]
            if (isNaN(i)) item.provide_way_1[key] = i.split(',').join('')
          })
        }
      })
      // 调用保存接口
      const res = await saveFullAttendanceBonus({ pfa_list: this.attendanceData.pfa_list })
      if (res.code === 1) {
        this.status = true
        this.$router.push({
          path: '/payroll/items'
        })
        this.$message({
          message: res.message,
          type: 'success'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1-box {
  padding: 0;
}
.management {
  &-content {
    color: #262626;
    padding-bottom: 52px;
    background: #f5f7f9;
  }
  &-item {
    background: #fff;
    margin-bottom: 24px;
    .common-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #262626;
    }
  }
  &-form {
    padding: 24px 24px 1px 24px;
    .el-select {
      width: 408px;
      /deep/ .el-tag {
        color: #262626;
      }
    }
    .el-switch {
      margin-right: 24px;
    }
    /deep/ .el-input {
      max-width: 408px;
    }
    /deep/.el-form-item__label {
      color: #262626;
    }
    .tip {
      padding-top: 8px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #8c8c8c;
    }
  }
}

.add-more {
  margin-right: 10px;
  .el-icon-circle-plus-outline {
    font-size: 16px;
  }
}
.add-item {
  width: 100%;
  height: 32px;
  display: block;
  border-style: dashed;
}

.el-icon-delete {
  color: #8c8c8c;
  margin: 0;
  &:hover {
    color: #ff4d4f;
  }
}
.provide_way_item {
  margin-bottom: 10px;
}

.number {
  /deep/ .el-input-number {
    &__increase,
    &__decrease {
      display: none;
    }
  }
}
</style>
